import {
  SegmentsStationStatusDto,
  segmentsGetStationStatusStatusesQueryKey,
  useSegmentsGetStationStatusStatuses,
} from '@mi-front/api-v2';

type UseStationStatusesOptions = NonNullable<
  Parameters<typeof useSegmentsGetStationStatusStatuses<SegmentsStationStatusDto[]>>[1]
>['query'];

/**
 * React Query wrapper around api-v2 station status list endpoint.
 */
export function useStationStatuses(options?: UseStationStatusesOptions) {
  return useSegmentsGetStationStatusStatuses<SegmentsStationStatusDto[]>(undefined, {
    query: options,
  });
}

useStationStatuses.queryKey = () => segmentsGetStationStatusStatusesQueryKey();
